/* global Sentry */
import React from 'react'
import { render } from 'react-dom'
import { Switch, Route, BrowserRouter } from 'react-router-dom'

import ThemeProvider from 'styles/ThemeProvider'
import FlashMessageProvider from '../creators/common/flashMessages/FlashMessageProvider'
import FlashMessagesContainer from 'creators/common/flashMessages/FlashMessagesContainer'
import Root from './Root'
import styled from 'styled-components'
import DebugProvider from 'shared/debug/DebugProvider.debug'
import QuickConnectDevtool from 'shared/debug/QuickConnectDevtool.debug'
import FeatureFlagProvider from 'shared/FeatureFlagProvider'
import FacebookSdkProvider from '../creators/FacebookSdkProvider'

// temp "give sentry some rest" patch until we find the real cause of https://sentry.io/organizations/videoagency/issues/2466197434
window.onunhandledrejection = e => {
  if (
    typeof e.reason?.toString() === 'string' &&
    e.reason.toString().includes('Object Not Found Matching Id:5')
  ) {
    // avg 30k per day => make it 300
    if (Math.floor(Math.random() * 100) === 0) {
      Sentry.captureException(e.reason)
    }
  } else Sentry.captureException(e.reason)
}

document.addEventListener('DOMContentLoaded', () => {
  render(
    <DebugProvider>
      <ThemeProvider>
        <FlashMessageProvider>
          <FacebookSdkProvider>
            <FeatureFlagProvider>
              <BrowserRouter>
                <FlashContainer>
                  <FlashMessagesContainer />
                </FlashContainer>
                <Switch>
                  <Route exact path="/creators/sign_up" component={Root} />
                  <Route exact path="/login" component={Root} />
                </Switch>
                <QuickConnectDevtool />
              </BrowserRouter>
            </FeatureFlagProvider>
          </FacebookSdkProvider>
        </FlashMessageProvider>
      </ThemeProvider>
    </DebugProvider>,
    document.getElementById('creators-registration-app')
  )
})

const FlashContainer = styled.div`
  left: 50%;
  position: fixed;
  transform: translateX(-50%);
`
